__turbopack_context__.v({
  "shrink": "Header-module-scss-module__TB32cG__shrink",
});
